import {
  IconChartArrowsVertical,
  IconPackage,
  IconShirt,
  IconStack2,
  IconSwords,
  IconTool,
  IconUser,
  IconUserShield,
} from '@tabler/icons-react';

export const menu = [
  { link: '/items/all', label: 'all', icon: IconStack2 },
  {
    link: '#items',
    label: 'items',
    icon: IconPackage,
    categories: [
      'combat',
      'magical',
      'skillbook',
      'servant',
      'petadult',
      'petorb',
      'service',
      'dyeitem',
      'medal',
      'pkitem',
      'order',
      'token',
      'quest',
      'document',
      'union',
      'etc',
      'other',
    ],
  },
  {
    link: '#character',
    label: 'character',
    icon: IconUser,
    categories: [
      'customize_accessory',
      'customize_armor',
      'customize_weapon',
      'crest',
      'crestpoint',
      'charm',
      'collection_card',
    ],
  },
  {
    link: '#craft',
    label: 'craft',
    icon: IconTool,
    categories: [
      'fishing',
      'collection',
      'cooking',
      'fabrication',
      'dyeraw',
      'alchemy',
      'leather',
      'fiber',
      'keyitem',
      'generalmaterial',
      'metal',
      'alchemymaterial',
      'armormaterial',
      'weaponmaterial',
      'armorcomponent',
      'weaponcomponent',
      'recipe',
      'dyerecipe',
      'extractrecipe',
    ],
  },
  {
    link: '#weapon',
    label: 'weapon',
    icon: IconSwords,
    categories: [
      'dual',
      'lance',
      'twohand',
      'axe',
      'circle',
      'bow',
      'staff',
      'rod',
      'chain',
      'blaster',
      'gauntlet',
      'shuriken',
      'glaive',
    ],
  },
  {
    link: '#equipment',
    label: 'equipment',
    icon: IconUserShield,
    categories: [
      'bodymail',
      'handmail',
      'feetmail',
      'bodyleather',
      'handleather',
      'feetleather',
      'bodyrobe',
      'handrobe',
      'feetrobe',
      'accessoryface',
      'accessoryhair',
      'belt',
      'ring',
      'earring',
      'necklace',
      'brooch',
      'holything',
      'relic',
      'underwear',
    ],
  },
  {
    link: '#enchant',
    label: 'enchant',
    icon: IconChartArrowsVertical,
    categories: [
      'enchant_agent',
      'enchant_material',
      'enchantcomponent',
      'enchantseal',
      'enchantscroll',
    ],
  },
  {
    link: '#styles',
    label: 'styles',
    icon: IconShirt,
    categories: [
      'style_body',
      'style_hair',
      'style_face',
      'style_back',
      'style_foot_print',
      'style_dual',
      'style_lance',
      'style_twohand',
      'style_circle',
      'style_bow',
      'style_staff',
      'style_rod',
      'style_chain',
      'style_blaster',
      'style_gauntlet',
      'style_shuriken',
      'style_glaive',
      'style_partner',
    ],
  },
];
